// Auto-generated theme: spacious
export default {
    '--sjs2-pdf-radius-question': 'var(--sjs2-radius-x100)',
    '--sjs2-pdf-radius-matrix': 'var(--sjs2-radius-x100)',
    '--sjs2-pdf-radius-checkbox': 'var(--sjs2-radius-x050)',
    '--sjs2-pdf-radius-radio': 'var(--sjs2-radius-round)',
    '--sjs2-pdf-radius-section': 'var(--sjs2-radius-x100)',
    '--sjs2-pdf-border-width-section': 'var(--sjs2-border-width-x000)',
    '--sjs2-pdf-border-width-question': 'var(--sjs2-border-width-x100)',
    '--sjs2-pdf-border-width-check': 'var(--sjs2-border-width-x100)',
    '--sjs2-pdf-layout-page-padding-top': 'var(--sjs2-spacing-x550)',
    '--sjs2-pdf-layout-page-padding-bottom': 'var(--sjs2-spacing-x550)',
    '--sjs2-pdf-layout-page-padding-left': 'var(--sjs2-spacing-x550)',
    '--sjs2-pdf-layout-page-padding-right': 'var(--sjs2-spacing-x550)',
    '--sjs2-pdf-layout-page-gap-vertical': 'var(--sjs2-spacing-x400)',
    '--sjs2-pdf-layout-page-gap-horizontal': 'var(--sjs2-spacing-x400)',
    '--sjs2-pdf-layout-page-questions-gap-horizontal': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-page-questions-gap-vertical': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-page-matrix-gap-horizontal': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-page-matrix-gap-vertical': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-title-large-gap': 'var(--sjs2-spacing-x150)',
    '--sjs2-pdf-layout-title-large-padding-bottom': 'var(--sjs2-spacing-x000)',
    '--sjs2-pdf-layout-title-medium-gap': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-title-medium-padding-bottom': 'var(--sjs2-spacing-x000)',
    '--sjs2-pdf-layout-title-default-gap': 'var(--sjs2-spacing-x050)',
    '--sjs2-pdf-layout-title-default-padding-bottom': 'var(--sjs2-spacing-x000)',
    '--sjs2-pdf-layout-section-padding-vertical': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-section-padding-horizontal': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-section-gap': 'var(--sjs2-spacing-x050)',
    '--sjs2-pdf-layout-check-padding-vertical': 'var(--sjs2-spacing-x000)',
    '--sjs2-pdf-layout-check-padding-horizontal': 'var(--sjs2-spacing-x050)',
    '--sjs2-pdf-layout-check-gap': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-matrix-padding-vertical': 'var(--sjs2-spacing-x000)',
    '--sjs2-pdf-layout-matrix-padding-horizontal': 'var(--sjs2-spacing-x050)',
    '--sjs2-pdf-layout-matrix-gap': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-question-padding-vertical': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-question-padding-horizontal': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-question-gap': 'var(--sjs2-spacing-x100)',
    '--sjs2-pdf-layout-question-labels-gap-vertical': 'var(--sjs2-spacing-x050)',
    '--sjs2-pdf-layout-question-items-gap-vertical': 'var(--sjs2-spacing-x050)',
    '--sjs2-pdf-layout-question-items-gap-horizontal': 'var(--sjs2-spacing-x150)',
    '--sjs2-pdf-layout-image-picker-items-gap-image-check': 'var(--sjs2-spacing-x100)'
};
